import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from "react-redux";

import { makeStyles } from '@material-ui/core/styles';
import {FormControl, InputLabel, Select as MuiSelect, FormHelperText} from '@material-ui/core/';

import generateId from '../../utils/generateId';
import makePath from '../../utils/makePath';
import { setItem } from "../../actions";
import { useDirty, useFormElementCleanUp, useValidation } from '../../hooks';
import { FormElementWrapper } from './FormElementWrapper';
import { ErrorHelpText } from './ErrorHelpText';


const useStyles = makeStyles((theme) => ({
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));


export const Select = React.memo(({callback,given,help,label,name,options,optional, ...props}) => {
  
  const [id] = useState(generateId('select-'));
  
  const classes = useStyles();
  const dispatch = useDispatch();
  const setDirty = useDirty();

  const path = makePath(props.path,name);
  useFormElementCleanUp(path);

  const [value, setValue] = useState(given ? given : options[0].value);


  // Validation conditions
  const validate = () => {

    if (!value && !optional) {
      setError('Missing! This field is required.');
    } else {
      setError('')
    }
    
  }

  // Apply validation conditions
  const [error, setError] = useValidation(validate,value,path,id);


  // Update state from user input
  const handleChange = (e) => {
    const { value } = e.target;
    setValue(value)
    setDirty();
  }

  // Update store and parent (if applicable) when value updates
  useEffect(() => {
    dispatch(setItem(path, value));
    if (callback) { 
      callback(name, value);
    }
  }, [callback,dispatch,name,path,value])

  
  // Set state from given value, if provided
  useEffect(() => {
    if (given) {
      setValue(given);
    }
  }, [given]);


  

  return (
    <FormElementWrapper fullWidth={props.fullWidth} >

      <FormControl fullWidth variant="outlined" className={classes.formControl}> 
      
        <InputLabel htmlFor={id} error={!!error}>{label}</InputLabel>

        <MuiSelect
          native
          value={value}
          onChange={handleChange}
          label={label}
          name={name}
          error={!!error}
          aria-describedby={`${id}-error ${id}-help`}
          inputProps={{
            name, id
          }}
        >
          {/* <option aria-label="None" value="" /> */}
          {
            options.map((option, index) => {
              return <option key={index} value={option.value}>{option.label}</option>
            })
          }
        </MuiSelect>

        {error ? 
          <ErrorHelpText error={error} id={id} />
        : '' }

        {help ? 
          <FormHelperText id={`${id}=help`}>{help}</FormHelperText>
        : '' }
      
      </FormControl>
    </FormElementWrapper>
  );

});

Select.propTypes = {
  callback: PropTypes.func,
  classes: PropTypes.string,
  label: PropTypes.string.isRequired, 
  name: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  path: PropTypes.string
}